// extracted by mini-css-extract-plugin
export default {"container":"ZQ-z","title":"_Q-z","link":"aR-z"};